import { CSSProperties } from 'react'

export const maxHeight = 20
export const maxWidth = 90

export const defaultLogoStyle = {
  maxHeight: `${maxHeight}px`,
  maxWidth: `${maxWidth}px`,
  objectFit: 'contain'
} as CSSProperties

export const defaultLogoStyleSquareImg = {
  maxHeight: '36px',
  maxWidth: '36px',
  objectFit: 'contain'
} as CSSProperties
